var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgErase = function SvgErase(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18H21q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 21 20h-5.75zM5.175 20q-.2 0-.388-.075a1 1 0 0 1-.337-.225l-1.825-1.825q-.575-.575-.587-1.425T2.6 15l11-11.4q.575-.6 1.412-.6.838 0 1.413.575L21.4 8.55q.575.575.575 1.425T21.4 11.4l-8.1 8.3q-.15.15-.338.225-.187.075-.387.075zm6.975-2L20 9.95 15.05 5 4 16.4 5.6 18z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErase);
export { ForwardRef as ReactComponent };